export default "__VITE_ASSET__DJgCLOgV__"